import { t, Trans } from '@lingui/macro';
import { map } from 'lodash';
import MenuItem from '@material-ui/core/MenuItem';
import NgpTextField from '../../../../form/NgpTextField';
import NgpSelect from '../../../../form/NgpSelect';
import { HTTP_RESPONSE_CODES } from '../../../../panels/web-test-now-panels/WebTestConstants';
import TestFormSection from './TestFormSection/TestFormSection';

const TestExpectedResponseSection = () => {
    return (
        <TestFormSection title={<Trans>Expected Response</Trans>}>
            <div style={{ width: 400 }}>
                <NgpSelect fieldName="testConfig.responseCode" label={t`HTTP Response Code`} required fullWidth>
                    {map(HTTP_RESPONSE_CODES, (label, code) => (
                        <MenuItem key={code} value={code}>
                            {label}
                        </MenuItem>
                    ))}
                </NgpSelect>
            </div>
            <div style={{ width: 450 }}>
                <NgpTextField
                    fieldName="testConfig.html.httpResponseContains"
                    label={t`HTML should contain`}
                    inputProps={{ size: 60, maxLength: 255 }}
                    fullWidth
                />
            </div>
            <div style={{ width: 450 }}>
                <NgpTextField
                    fieldName="testConfig.html.httpResponseNotContains"
                    label={t`HTML should not contain`}
                    inputProps={{ size: 60, maxLength: 255 }}
                    fullWidth
                />
            </div>
        </TestFormSection>
    );
};

export default TestExpectedResponseSection;
